import { render } from "./BelegInTd.pug?vue&type=template&id=96a7e0a6&lang=pug"
import script from "./BelegInTd.js?vue&type=script&lang=js"
export * from "./BelegInTd.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__